// extracted by mini-css-extract-plugin
export default {"textCard":"text-card_textCard__AltVV"};